import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import MKBox from "components/MKBox";

import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

function Counters() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={77}
              suffix="%"
              title="Taxa de Matrícula de Estudantes Surdos no Ensino Regular"
              description="De acordo com dados do Instituto Nacional de Estudos e Pesquisas Educacionais Anísio Teixeira (INEP) de 2020, aproximadamente 77% dos estudantes surdos estavam matriculados em classes regulares em escolas inclusivas no Brasil. Este número reflete a política de inclusão que tem sido promovida para integrar estudantes surdos no ensino regular ao invés de escolas ou classes segregadas."
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard
              count="7"
              suffix=",4%"
              title="Acesso à Educação Superior"
              description="Segundo um relatório do Instituto Brasileiro de Geografia e Estatística (IBGE) de 2019, apenas 7,4% das pessoas com deficiência auditiva completam o ensino superior no Brasil. Este número é significativamente inferior à média da população geral, indicando desafios contínuos para a inclusão efetiva de surdos em níveis mais altos de educação."
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={30}
              suffix="%"
              title="Presença de Intérpretes de Libras"
              description="Em uma pesquisa realizada pelo Ministério da Educação em 2018, foi constatado que menos de 30% das escolas brasileiras tinham intérpretes de Libras (Língua Brasileira de Sinais) disponíveis para apoiar alunos surdos. A falta de intérpretes é uma das principais barreiras para a inclusão eficaz e o aprendizado dos estudantes surdos nas escolas regulares."
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
